<!-- TODO: Add track link attributes -->
<div class="dealer-info-standard-map">
  <div class="row">
    <div class="col-12 col-md-6">
      <div class="dealer-info-pane js-dealer-info-pane" tabindex="-1">

        <div class="dealer-info-standard" *ngIf="dealer">
          <span class="gb-headline3" role="heading" aria-level="3">{{dealer.name}}</span>
          <ul>
            <li class="margin-bottom-none gb-body1">{{dealer.zipCode}}</li>
            <li class="margin-bottom-none gb-body1">{{dealer.city}} {{dealer.addressLine2}}</li>
            <li class="margin-bottom-none gb-body1">{{dealer.street}}</li>
          </ul>

          <hr class="light">
          <div class="margin-bottom-large">
            <ul class="margin-bottom-medium">
              <li *ngIf="cmsPrefix">
                <span class="heavy gb-body1" [translate]="cmsPrefix+'_dealer_servicePhoneLabel'">
                </span>&nbsp;
                <a class="noWrap"
                  [href]="'tel:+' + dealer.servicePhone"
                  oxTrackLink
                  [trackLink]="trackLinkPrefix+': Service Phone Number'"
                  [trackDelay]="'true'"
                  [trackType]="'o'"
                  [prop10]="prop10Prefix+':link:service phone number:'+dealer.name+':'+dealer.servicePhone">
                  <span class="gb-body1">{{dealer.servicePhone}}</span>
                </a>
              </li>
            </ul>
            <ul>
              <li class="gb-body1"
                  *ngIf="dealer.dealerWebSite"
                  oxTrackLink
                  [trackLink]="trackLinkPrefix+':DealerWebsite'"
                  [trackDelay]="'this'"
                  [trackType]="'e'"
                  [prop10]="prop10Prefix+':link:dealer website'">
                <a class="noWrap dealerWebsiteLink"
                   [href]="dealer.dealerWebSite"
                   disabled="!dealership.dealer.certifiedInternet"
                   aria-haspopup="dialog"
                   aria-expanded="false"
                   [attr.aria-label]="dealer.name + ('aoda_open_new_window_aria_label' | translate)">
                  <span *ngIf="cmsPrefix" [translate]="cmsPrefix+'_dealerWebsite'"></span>&nbsp;
                  <span role="presentation" class="icon-ui-newwindow"></span>
                </a>
              </li>
            </ul>
          </div>

          <div>
            <span class="heavy gb-body1" *ngIf="cmsPrefix" [translate]="cmsPrefix+'_dealer_specialtyServicesLabel'"></span>
            <ul class="list-styled" *ngFor="let service of dealer.specialtyServices">
              <li>
                <span class="gb-body2">{{service}}</span>
              </li>
            </ul>
          </div>

          <hr class="light">

          <ul class="list-inline">
            <li class="gb-body1"
                oxTrackLink
                [trackLink]="trackLinkPrefix+':ScheduleService'"
                [trackDelay]="'this'"
                [trackType]="'e'"
                [prop10]="prop10Prefix+':button:schedule service'">
                <div [ngSwitch]="vehicleMake">
                  <div *ngSwitchCase="'chevrolet'">
                    <a class="noWrap" target="_blank" [href]="'schedule_service_link_chevy' | translate: {bac: this.dealer.bac}">
                      <span class="icon-graphic-service"></span>&nbsp;
                      <span *ngIf="cmsPrefix" [translate]="cmsPrefix+'_scheduleServiceBtn'"></span>
                    </a>
                  </div>
                  <div *ngSwitchCase="'gmc'">
                    <a class="noWrap" target="_blank" [href]="'schedule_service_link_gmc' | translate: {bac: this.dealer.bac}">
                      <span class="icon-graphic-service"></span>&nbsp;
                      <span *ngIf="cmsPrefix" [translate]="cmsPrefix+'_scheduleServiceBtn'"></span>
                    </a>
                  </div>
                  <div *ngSwitchCase="'cadillac'">
                    <a class="noWrap" target="_blank" [href]="'schedule_service_link_cadillac' | translate: {bac: this.dealer.bac}">
                      <span class="icon-graphic-service"></span>&nbsp;
                      <span *ngIf="cmsPrefix" [translate]="cmsPrefix+'_scheduleServiceBtn'"></span>
                    </a>
                  </div>
                  <div *ngSwitchCase="'other'">
                    <a class="noWrap" target="_blank" [href]="'schedule_service_link_other' | translate: {bac: this.dealer.bac}">
                      <span class="icon-graphic-service"></span>&nbsp;
                      <span *ngIf="cmsPrefix" [translate]="cmsPrefix+'_scheduleServiceBtn'"></span>
                    </a>
                  </div>
                </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6">
      <p class="text-center mb-1" *ngIf="isFirefox">
        <!-- aoda_firefox_map_message cms is not defined -->
        <span class="gb-body2" [translate]="'aoda_firefox_map_message'"></span>
      </p>
      <div class="dealer-map-canvas gray-stroke js-dealer-map-canvas"></div>
    </div>
  </div>
</div>
